import { formatAmount } from '@shared/lib/money'
import { OperationDetailsRs } from '@root/api/ump-ewallet'

export const getOperationDetailsBaseAmount = (
  operationDetails: OperationDetailsRs,
  isCardPayment: boolean | undefined,
  isPubg: boolean,
  isTopUpWithPercentFeeService: boolean,
  isNonTopUpServiceDenomation: boolean
) => {
  if (isCardPayment) {
    return operationDetails?.amount?.base || ''
  }

  if (isPubg || isTopUpWithPercentFeeService) {
    return (
      Number(formatAmount(operationDetails?.amount?.base ?? '0')) +
      Number(formatAmount(operationDetails?.amount?.fee ?? '0'))
    ).toFixed(2)
  }

  if (isNonTopUpServiceDenomation) {
    return formatAmount(operationDetails?.amount?.base ?? '0') + 50
  }

  return operationDetails?.amount?.base.toString() ?? ''
}
